import React from 'react';
import { Space, Input, Button, DatePicker } from 'antd';
import { Label } from '../Layouts';
import { SearchProjectParams } from '../../api/project';
import LocaltionSelect from '../common/LocationSelect';
import dayjs from 'dayjs'

export type SearchParams = SearchProjectParams;

const ProjectFilter: React.FC<{ isAdmin?:boolean, onSearch: () => void, values: SearchParams, onChange: (v: SearchParams) => void, }> =
    ({ values: params, onChange: setParams, onSearch, isAdmin }) => {
        return (
            <Space>
                <Label>
                    <Label>展会名称</Label>
                    <Input.Search
                        onSearch={() => onSearch()}
                        onKeyUp={e => {
                            if (e.key === 'Enter') {
                                onSearch()
                            }
                        }}
                        onChange={e => {
                            setParams({ ...params, projectName: e.target.value })
                        }} value={params.projectName} placeholder='请输入展会名称' />
                </Label>

                <Label>
                    <Label>展馆</Label>
                    <LocaltionSelect
                        style={{ width: 180 }}
                        allowClear={isAdmin === true}
                        value={params.organizationId} onChange={organizationId => {
                            setParams({
                                ...params,
                                organizationId
                            })
                        }} />
                </Label>

                <Label>
                    <Label>创建时间</Label>
                    <DatePicker.RangePicker
                     needConfirm={false}
                        value={[
                            params.createDateRangeStart ? dayjs(params.createDateRangeStart) : null,
                            params.createDateRangeEnd ? dayjs(params.createDateRangeEnd) : null,
                        ]}
                        onChange={(_, [createDateRangeStart, createDateRangeEnd]) => {
                            setParams({
                                ...params,
                                createDateRangeStart,
                                createDateRangeEnd
                            })
                        }}
                        placeholder={['创建时间(起)', '创建时间(止)']} />
                </Label>

                <Label>
                    <Label>展会开始时间</Label>
                    <DatePicker.RangePicker
                     needConfirm={false}
                        value={[
                            params.startDateRangeStart ? dayjs(params.startDateRangeStart) : null,
                            params.startDateRangeEnd ? dayjs(params.startDateRangeEnd) : null,
                        ]}
                        onChange={(_, [startDateRangeStart, startDateRangeEnd]) => {
                            setParams({
                                ...params,
                                startDateRangeStart,
                                startDateRangeEnd
                            })
                        }}
                        placeholder={['展会开始时间(起)', '展会开始时间(止)']} />
                </Label>

                <Label>
                    <Label>展会结束时间</Label>
                    <DatePicker.RangePicker
                     needConfirm={false}
                        value={[
                            params.endDateRangeStart ? dayjs(params.endDateRangeStart) : null,
                            params.endDateRangeEnd ? dayjs(params.endDateRangeEnd) : null,
                        ]}
                        onChange={(_, [endDateRangeStart, endDateRangeEnd]) => {
                            setParams({
                                ...params,
                                endDateRangeStart,
                                endDateRangeEnd
                            })
                        }}
                        placeholder={['展会结束时间(起)', '展会结束时间(止)']} />
                </Label>

                <Button onClick={onSearch} style={{ marginTop: '1.4em' }} type='primary'>查询</Button>
            </Space>
        );
    }

export default ProjectFilter;